import { render, staticRenderFns } from "./OmnichannelStrategyTable.vue?vue&type=template&id=05418bd1&scoped=true"
import script from "./OmnichannelStrategyTable.vue?vue&type=script&lang=ts"
export * from "./OmnichannelStrategyTable.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelStrategyTable.vue?vue&type=style&index=0&id=05418bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05418bd1",
  null
  
)

export default component.exports